if (!customElements.get('faq-navigation')) {
  class FaqNavigation extends HTMLElement {
    constructor() {
      super();
      this.navLinks = [];
      this.categoryIds = [];
    }

    connectedCallback() {
      this.navLinks = this.querySelectorAll('[data-faq-nav-link]');
      this.categories = this.querySelectorAll('.faq-nav__category');
      
      this.navLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href) this.categoryIds.push(href.substring(1));
      });

      this.setupNavigation();
      this.setupScrollSpy();
      this.updateActiveLink();
    }

    setupNavigation() {
      this.navLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);
          
          if (targetElement) {
            const headerOffset = 120;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            this.setActiveLink(link);
          }
        });
      });
    }

    setupScrollSpy() {
      let ticking = false;
      
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            this.updateActiveLink();
            ticking = false;
          });
          ticking = true;
        }
      });
    }

    updateActiveLink() {
      const scrollPosition = window.scrollY + 150;
      
      for (let i = 0; i < this.categoryIds.length; i++) {
        const category = document.getElementById(this.categoryIds[i]);
        if (!category) continue;
        
        const categoryTop = category.offsetTop;
        const nextCategory = this.categoryIds[i + 1] ? document.getElementById(this.categoryIds[i + 1]) : null;
        const categoryBottom = nextCategory ? nextCategory.offsetTop : categoryTop + category.offsetHeight;
        
        if (scrollPosition >= categoryTop && scrollPosition < categoryBottom) {
          this.setActiveLink(this.navLinks[i]);
          break;
        }
      }
    }

    setActiveLink(activeLink) {
      this.navLinks.forEach(l => l.classList.remove('faq-nav__link--active'));
      if (activeLink) {
        activeLink.classList.add('faq-nav__link--active');
      }
    }
  }

  customElements.define('faq-navigation', FaqNavigation);
}
